var map = {
	"./fundamentals/hr-drive-included.png": "+NBl"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "YfzE";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\/hr\-drive\-included\.png$
// module id = YfzE
// module chunks = 0